import React, { useContext } from 'react';
import {
  StyleSheet,
  View,
  Text,
  FlatList,
  TouchableOpacity,
  ActivityIndicator,
} from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import { Ionicons } from '@expo/vector-icons';
import { ClientContext } from '../context/ClientContext';

const ClientSelectionScreen = ({ navigation }) => {
  const { clientList, selectedClient, selectClient, isLoading } = useContext(ClientContext);

  const handleSelectClient = (client) => {
    selectClient(client);
    navigation.goBack();
  };

  if (isLoading) {
    return (
      <View style={styles.loadingContainer}>
        <ActivityIndicator size="large" color="#3498db" />
        <Text style={styles.loadingText}>Loading clients...</Text>
      </View>
    );
  }

  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.headerContainer}>
        <Text style={styles.headerText}>Select a client to view their data</Text>
      </View>

      {clientList.length === 0 ? (
        <View style={styles.emptyContainer}>
          <Ionicons name="business-outline" size={64} color="#bdc3c7" />
          <Text style={styles.emptyText}>No clients available</Text>
          <Text style={styles.emptySubtext}>
            You don't have access to any clients yet. Please contact your administrator.
          </Text>
        </View>
      ) : (
        <FlatList
          data={clientList}
          keyExtractor={(item) => item.clientId.toString()}
          renderItem={({ item }) => (
            <TouchableOpacity
              style={[
                styles.clientItem,
                selectedClient?.clientId === item.clientId && styles.selectedItem,
              ]}
              onPress={() => handleSelectClient(item)}
            >
              <View style={styles.clientContent}>
                <Text style={styles.clientName}>{item.clientName}</Text>
                {selectedClient?.clientId === item.clientId && (
                  <Ionicons name="checkmark-circle" size={24} color="#2ecc71" />
                )}
              </View>
            </TouchableOpacity>
          )}
          contentContainerStyle={styles.listContent}
        />
      )}
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f5f5f5',
  },
  headerContainer: {
    padding: 16,
    backgroundColor: '#f5f5f5',
    borderBottomWidth: 1,
    borderBottomColor: '#e0e0e0',
  },
  headerText: {
    fontSize: 16,
    color: '#7f8c8d',
  },
  listContent: {
    padding: 16,
  },
  clientItem: {
    backgroundColor: '#fff',
    borderRadius: 8,
    padding: 16,
    marginBottom: 12,
    elevation: 2,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 2,
  },
  selectedItem: {
    borderWidth: 2,
    borderColor: '#3498db',
  },
  clientContent: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  clientName: {
    fontSize: 18,
    fontWeight: '500',
    color: '#2c3e50',
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: '#f5f5f5',
  },
  loadingText: {
    marginTop: 16,
    fontSize: 16,
    color: '#7f8c8d',
  },
  emptyContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 24,
  },
  emptyText: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#7f8c8d',
    marginTop: 16,
  },
  emptySubtext: {
    fontSize: 14,
    color: '#95a5a6',
    textAlign: 'center',
    marginTop: 8,
    maxWidth: '80%',
  },
});

export default ClientSelectionScreen;